import React, { type FC } from "react"

import { SectionTitleSlideTemplate } from "../../SlideTemplates/SectionTitleSlide"

export const AriaTitle: FC = () => <SectionTitleSlideTemplate heading="ARIA" />
